import React, { useMemo } from "react";
import { ScaleLoader } from "react-spinners";

const Loader = () => {
  const storedBranding = useMemo(() => {
    try {
      return JSON.parse(sessionStorage.getItem("branding"));
    } catch (error) {
      return null;
    }
  }, []);
  const appearance = storedBranding?.data?.appearance;
  const loaderColor = appearance?.theme_colour || "#9ab767";

  return (
    <div
      className="w-full flex items-center justify-center gap-2"
      style={{ height: "300px" }}
    >
      <ScaleLoader size={150} color={loaderColor} />
    </div>
  );
};

export default Loader;
